module.exports = __webpack_public_path__ + "img/loc.e13a1fb8.svg";